<div [ngSwitch]="getLoaderType()">
    <div *ngSwitchCase="'clearview'" class="loadViewArea" [ngClass]="{ 'whiteOverlay fadeInOverlay': overlay }">
        <div class="ng-loader-container" [ngClass]="sizeClass">
            <mat-progress-spinner class="track" [diameter]="sizePixels" [mode]="'determinate'" [value]="100" ></mat-progress-spinner>
            <mat-progress-spinner class="loader" [ngClass]="sizeClass" [diameter]="sizePixels" [mode]="'indeterminate'"></mat-progress-spinner>
        </div>
    </div>
    <cxone-spinner *ngSwitchCase="'cxone'" [isSpinner]="cxoneIsSpinner"></cxone-spinner>
</div>